import theme from '~/style/theme'

const MODAL_STYLES = {
  mobile: {
    general: {
      overlay: {
        zIndex: 2,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme.colors.background.main
      },
      content: {
        width: '100%',
        height: '100%',
        padding: '1rem',
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        overflowX: 'hidden',
        overflowY: 'auto'
      }
    },
    generalNoPadding: {
      overlay: {
        zIndex: 2,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme.colors.background.main
      },
      content: {
        width: '100%',
        height: '100%',
        padding: '0',
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        overflowX: 'hidden',
        overflowY: 'auto'
      }
    },
    faq: {
      overlay: {
        zIndex: 2,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme.colors.background.page
      },
      content: {
        width: '100%',
        height: '100%',
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: 0
      }
    },
    impactPopup: {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(20, 25, 28, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      content: {
        background: '#fff',
        width: '100%',
        maxWidth: 1000,
        borderRadius: 6,
        height: '90%',
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        margin: '2rem',
        overflowX: 'hidden',
        overflowY: 'auto'
      }
    },
  },
  desktop: {
    evidence: {
      overlay: {
        zIndex: 2,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(20, 25, 28, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
        // padding: '2rem'
      },
      content: {
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        margin: '2rem'
      }
    },
    forms: {
      overlay: {
        zIndex: 2,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(20, 25, 28, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
        // padding: '2rem'
      },
      content: {
        background: 'none',
        border: 'none',
        borderRadius: 'none',
        width: '100%',
        maxWidth: 780,
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        margin: '2rem'
      }
    },
    impactPopup: {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(20, 25, 28, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      content: {
        // position: 'relative',
        background: '#fff',
        width: '100%',
        maxWidth: 1000,
        // height: '100%',
        borderRadius: 6,
        height: '575x',
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        margin: '2rem',
        overflowX: 'hidden',
        overflowY: 'auto'
      }
    },
    general: {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(20, 25, 28, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      content: {
        // position: 'relative',
        background: '#fff',
        width: '100%',
        maxWidth: 780,
        // height: '100%',
        borderRadius: 6,
        maxHeight: 510,
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        padding: '20px',
        margin: '2rem',
        overflowX: 'hidden',
        overflowY: 'auto'
      }
    },
    generalNoPadding: {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(20, 25, 28, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      content: {
        // position: 'relative',
        background: '#fff',
        width: '100%',
        maxWidth: 780,
        // height: '100%',
        borderRadius: 6,
        // maxHeight: 490,
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        padding: '0',
        margin: '2rem'
      }
    },
    topGray: {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(20, 25, 28, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      content: {
        background: '#fff',
        width: '100%',
        maxWidth: 780,
        borderRadius: 6,
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        padding: '0',
        margin: '2rem'
      }
    }
  }
}

export default MODAL_STYLES
